if (!customElements.get("newsletter-popup")) {
  class NewsletterPopup extends ModalDialog {
    constructor() {
      super();
      this.init();
      this.attachEventListeners();
    }

    attachEventListeners() {
      this.querySelectorAll(".js-button-close").forEach(btn => {
        btn.addEventListener("click", this.closeNewsletter.bind(this));
      });
    }

    init() {
      this.delay = this.dataset.delay * 1000;
      this.ageVerificationPopup = document.querySelector("age-verification-popup");
    }

    closeNewsletter() {
      setCookie("newsletter-closed", "true");
      this.hide();
      this.releaseBodyScroll();
    }

    connectedCallback() {
      if (Shopify.designMode) {
        if (this.dataset.openInDesignMode === "true") {
          this.show();
        }
        return;
      }

      // A customer form submit reloads the page. If this popup's form was just
      // submitted, reopen it immediately so the shopper sees the success (or
      // error) message instead of the popup silently disappearing. It then stays
      // open until they click the close button or click outside.
      if (this.wasJustSubmitted()) {
        this.showAfterSubmit();
        return;
      }

      this.handlePopupVisibility();
    }

    // True when the page reloaded right after this popup's newsletter form was
    // posted — Liquid renders a success/error message that is otherwise hidden.
    wasJustSubmitted() {
      const message = this.querySelector("[data-message]");
      return !!message && !message.classList.contains("hidden");
    }

    showAfterSubmit() {
      const errored = this.querySelector(".newsletter__field")?.classList.contains("has-error");
      // Remember a successful subscribe so the popup doesn't reappear on later
      // visits; on error leave it unset so the shopper can try again.
      if (!errored) setCookie("newsletter-subscribed", "true");
      this.show();
    }

    handlePopupVisibility() {
      if (getCookie("age-verified") !== "true" && this.ageVerificationPopup) {
        this.handleAgeVerificationPopup();
      } else {
        this.showPopupWithDelay();
      }
    }

    handleAgeVerificationPopup() {
      let prevClassState = this.classList.contains("newsletter-popup-is-hidden");

      const observer = new MutationObserver(mutations => {
        const mutation = mutations[0];
        if (mutation.attributeName !== "class") return;

        const currentClassState = mutation.target.classList.contains("newsletter-popup-is-hidden");

        if (prevClassState !== currentClassState) {
          prevClassState = currentClassState;
          if (!currentClassState) {
            this.showPopupWithDelay();
          }
        }
      });

      observer.observe(this, { attributes: true });
    }

    showPopupWithDelay() {
      setTimeout(() => {
        if (this.isDismissed() || this.isHidden()) return;
        this.show();
      }, this.delay);
    }

    // Read the cookies now rather than reusing the values captured in `init()`:
    // every popup shares them, and one may have been closed while this timer ran.
    isDismissed() {
      return getCookie("newsletter-closed") === "true" || getCookie("newsletter-subscribed") === "true";
    }

    // A section hidden by a responsive `display: none` still runs this timer.
    // Opening it would lock body scroll behind a popup nobody can see or close.
    // The closed popup is `visibility: hidden`, not `display: none`, so it still
    // has a box here; only a hidden ancestor collapses it to zero.
    isHidden() {
      return this.offsetWidth === 0 && this.offsetHeight === 0;
    }

    // The close button doubles as the modal's `ModalClose-*` element, so a single
    // click runs `hide()` twice and each `bodyScroll.unlock` can write a stale
    // `overflow: hidden` back onto the body. Strip it once every handler has run.
    releaseBodyScroll() {
      requestAnimationFrame(() => document.body.style.removeProperty("overflow"));
    }
  }

  customElements.define("newsletter-popup", NewsletterPopup);
}
